<div *ngIf="!loading; else cargando" class="informes">
  <h2 style="text-align: center">INFORME FABRICA</h2>
  <div class="report-pres">
    <div class="grid-container">
      <div class="grid-item i1">
        <em>REPORT EN CURSO: {{ report.uuid }}</em>
      </div>
      <div class="grid-item i2">
        <em>CODIGO : {{ report.codigo }}</em>
      </div>
      <div class="grid-item i3" *ngIf="reportEdit">
        <em>TITULO:&nbsp;</em>
        <input class="input-report" type="text" [(ngModel)]="report.titulo" />
      </div>
      <div class="grid-item i3" *ngIf="!reportEdit">
        <em>TITULO:&nbsp;{{ report.titulo }}</em>
      </div>
      <div class="grid-item i4" *ngIf="reportEdit">
        <em>LOGO:&nbsp;</em>
        <input class="input-report" type="text" [(ngModel)]="report.logo" />
      </div>
      <div class="grid-item i4" *ngIf="!reportEdit">
        <em>LOGO:&nbsp;{{ report.logo }}</em>
      </div>
      <div class="grid-item i5" *ngIf="reportEdit">
        <em>IDIOMA:&nbsp;</em
        ><input class="input-report" type="text" [(ngModel)]="report.idioma" />
      </div>
      <div class="grid-item i5" *ngIf="!reportEdit">
        <em>IDIOMA:&nbsp;{{ report.idioma }}</em>
      </div>
      <div class="grid-item i6"><img [src]="report.logo" width="150px" /></div>
      <div class="grid-item i7">&nbsp;</div>
      <div class="grid-item i8">&nbsp;</div>
      <div class="grid-item i9">
        <button mat-button color="primary" (click)="editReport()">
          <mat-icon>create</mat-icon>
        </button>
      </div>
      <div class="grid-item i10">
        <a class="mat-raised-button binfo" routerLink="/informes"> Volver </a>
      </div>
    </div>
    <div style="padding: 20px">
      <mat-tab-group>
        <mat-tab label="REPORTPARAM">
          <table class="informe-tabla" BORDER="1" style="max-height: 100px">
            <caption>
              <br /><br />
            </caption>
            <thead>
              <th *ngFor="let tiRow of paramHead" style="text-align: center">
                {{ tiRow }}
              </th>
            </thead>
            <tbody *ngFor="let p of report.params; let i = index">
              <tr>
                <td>
                  <button mat-button color="primary" (click)="paramRowFun(i)">
                    <mat-icon>create</mat-icon>
                  </button>
                </td>
                <td>
                  <button mat-button color="primary" (click)="borrarParam(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
                <td>{{ p.uuid }}</td>
                <td>{{ p.codigo }}</td>
                <td>{{ p.periodo }}</td>
                <td>
                  <input
                    *ngIf="paramRow[i]"
                    type="text"
                    [(ngModel)]="p.unidadT"
                  />
                  <span *ngIf="!paramRow[i]">{{ p.unidadT }}</span>
                </td>
                <td>
                  <input
                    *ngIf="paramRow[i]"
                    type="text"
                    [(ngModel)]="p.unidadK"
                  />
                  <span *ngIf="!paramRow[i]">{{ p.unidadK }}</span>
                </td>
                <td>
                  <mat-form-field appearance="fill" style="width: 90%">
                    <mat-label>{{
                      paramRow[i] && p.clase ? p.clase : "Asignar clase"
                    }}</mat-label>
                    <mat-select
                      [(ngModel)]="p.clase"
                      [disabled]="!paramRow[i]"
                      matTooltip="Editar registro para cambiar la clase"
                      matTooltipPosition="above"
                    >
                      <mat-option
                        *ngFor="let c of classReportOptions"
                        [value]="c.code"
                      >
                        {{ c.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
                <td>
                  <input *ngIf="paramRow[i]" type="text" [(ngModel)]="p.tipo" />
                  <span *ngIf="!paramRow[i]">{{ p.tipo }}</span>
                </td>
                <td *ngIf="p.dato.uuid != undefined">
                  <button
                    mat-button
                    color="primary"
                    (click)="paramRowDato[i] = !paramRowDato[i]"
                  >
                    <mat-icon>{{
                      paramRowDato[i]
                        ? "keyboard_arrow_up"
                        : "keyboard_arrow_down"
                    }}</mat-icon>
                  </button>
                </td>
                <td *ngIf="p.dato.uuid === undefined">
                  <button
                    mat-button
                    color="primary"
                    (click)="reportParamFunDato(i)"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="paramRowDato[i] && p.dato.uuid != undefined">
                <td></td>
                <td colspan="7">
                  <table>
                    <tr>
                      <td>uuid:</td>
                      <td colspan="2">{{ p.dato.uuid }}</td>
                    </tr>
                    <tr>
                      <td>periodo:</td>
                      <td colspan="2">{{ p.dato.periodo }}</td>
                    </tr>
                    <tr>
                      <td>Disp.(uuid):</td>
                      <td colspan="2">{{ p.dato.dispositivo.uuid }}</td>
                    </tr>
                    <tr>
                      <td>Disp.(nombre):</td>
                      <td>{{ p.dato.dispositivo.nombre }}</td>
                      <td>
                        <button
                          mat-button
                          color="primary"
                          (click)="borrarParamDato(i)"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>Tipo.(uuid):</td>
                      <td colspan="2">{{ p.dato.tipoDato.uuid }}</td>
                    </tr>
                    <tr>
                      <td>Tipo.(nombre):</td>
                      <td colspan="2">{{ p.dato.tipoDato.nombre }}</td>
                    </tr>
                    <tr>
                      <td>Tipo.(unidad):</td>
                      <td colspan="2">{{ p.dato.tipoDato.unidad }}</td>
                    </tr>
                  </table>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div>
            <button mat-button color="primary" (click)="reportParamFun()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </mat-tab>
        <mat-tab label="REPORTROW ">
          <table class="informe-tabla" BORDER="1 " style="max-height: 100px">
            <caption>
              <br />
            </caption>
            <thead>
              <th *ngFor="let tiRow of rowHead" style="text-align: center">
                {{ tiRow }}
              </th>
            </thead>
            <tbody *ngFor="let p of report.rows; let i = index">
              <tr>
                <td>
                  <button mat-button color="primary" (click)="rowsEditfun(i)">
                    <mat-icon>create</mat-icon>
                  </button>
                </td>
                <td>
                  <button mat-button color="primary" (click)="borrarRow(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
                <td>{{ p.uuid }}</td>
                <td>
                  <input
                    *ngIf="rowsEdit[i]"
                    type="text"
                    [(ngModel)]="p.titulo"
                  />
                  <span *ngIf="!rowsEdit[i]">{{ p.titulo }}</span>
                </td>
                <td>
                  <input
                    *ngIf="rowsEdit[i]"
                    type="text"
                    [(ngModel)]="p.orden"
                  />
                  <span *ngIf="!rowsEdit[i]">{{ p.orden }}</span>
                </td>
                <td>
                  <input
                    *ngIf="rowsEdit[i]"
                    type="text"
                    [(ngModel)]="p.unidadT"
                  />
                  <span *ngIf="!rowsEdit[i]">{{ p.unidadT }}</span>
                </td>
                <td>
                  <input
                    *ngIf="rowsEdit[i]"
                    type="text"
                    [(ngModel)]="p.unidadK"
                  />
                  <span *ngIf="!rowsEdit[i]">{{ p.unidadK }}</span>
                </td>
                <td *ngIf="p.dato.length > 0">
                  <button
                    mat-button
                    color="primary"
                    (click)="rowsShow[i] = !rowsShow[i]"
                  >
                    <mat-icon>{{
                      rowsShow[i] ? "keyboard_arrow_up" : "keyboard_arrow_down"
                    }}</mat-icon>
                  </button>
                </td>
                <td *ngIf="p.dato.length === 0">
                  <button
                    mat-button
                    color="primary"
                    (click)="reportRowFunDato(i)"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="rowsShow[i] && p.dato.length > 0">
                <td colspan="8 ">
                  <!--<br>Datos:<br>-->
                  <table BORDER="1 ">
                    <tr *ngFor="let d of p.dato; let ii = index">
                      <td>
                        <button
                          mat-button
                          color="primary"
                          (click)="borrarRowDato(i, ii)"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                      <td>{{ d.uuid }}</td>
                      <td>{{ d.periodo }}</td>
                      <td>
                        <table>
                          <tr>
                            <td>Disp.(uuid):</td>
                            <td>{{ d.dispositivo.uuid }}</td>
                          </tr>
                          <tr>
                            <td>Disp.(nombre):</td>
                            <td>{{ d.dispositivo.nombre }}</td>
                          </tr>
                          <tr>
                            <td>Tipo.(uuid):</td>
                            <td>{{ d.tipoDato.uuid }}</td>
                          </tr>
                          <tr>
                            <td>Tipo.(nombre):</td>
                            <td>{{ d.tipoDato.nombre }}</td>
                          </tr>
                          <tr>
                            <td>Tipo.(unidad):</td>
                            <td>{{ d.tipoDato.unidad }}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div>
                    <button
                      mat-button
                      color="primary"
                      (click)="reportRowFunDato(i)"
                    >
                      <mat-icon>list_alt</mat-icon><mat-icon>add</mat-icon>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <button mat-button color="primary" (click)="reportRowFun()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </mat-tab>
        <mat-tab label="REPORTTABLE ">
          <table class="informe-tabla" BORDER="1 " style="max-height: 100px">
            <caption>
              <br />
            </caption>
            <thead>
              <th *ngFor="let ti of tableHead" style="text-align: center">
                {{ ti }}
              </th>
            </thead>
            <tbody *ngFor="let p of report.tables; let i = index">
              <tr>
                <td>
                  <button mat-button color="primary" (click)="tablesEditFun(i)">
                    <mat-icon>create</mat-icon>
                  </button>
                </td>
                <td>
                  <button mat-button color="primary" (click)="borrarTable(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
                <td>{{ p.uuid }}</td>
                <td>
                  <input
                    *ngIf="tablesEdit[i]"
                    type="text"
                    [(ngModel)]="p.titulo"
                  />
                  <span *ngIf="!tablesEdit[i]">{{ p.titulo }}</span>
                </td>
                <td>
                  <input
                    *ngIf="tablesEdit[i]"
                    type="text"
                    [(ngModel)]="p.consumoTitulo"
                  />
                  <span *ngIf="!tablesEdit[i]">{{ p.consumoTitulo }}</span>
                </td>
                <td>
                  <input
                    *ngIf="tablesEdit[i]"
                    type="text"
                    [(ngModel)]="p.consumoK"
                  />
                  <span *ngIf="!tablesEdit[i]">{{ p.consumoK }}</span>
                </td>
                <td>
                  <input
                    *ngIf="tablesEdit[i]"
                    type="text"
                    [(ngModel)]="p.itemTitulo"
                  />
                  <span *ngIf="!tablesEdit[i]">{{ p.itemTitulo }}</span>
                </td>
                <td>
                  <input
                    *ngIf="tablesEdit[i]"
                    type="text"
                    [(ngModel)]="p.itemK"
                  />
                  <span *ngIf="!tablesEdit[i]">{{ p.itemK }}</span>
                </td>
                <td>
                  <input
                    *ngIf="tablesEdit[i]"
                    type="text"
                    [(ngModel)]="p.ratioTitulo"
                  />
                  <span *ngIf="!tablesEdit[i]">{{ p.ratioTitulo }}</span>
                </td>
                <td>
                  <input
                    *ngIf="tablesEdit[i]"
                    type="text"
                    [(ngModel)]="p.ratiomedioTitulo"
                  />
                  <span *ngIf="!tablesEdit[i]">{{ p.ratiomedioTitulo }}</span>
                </td>
                <td *ngIf="p.dispositivos.length > 0">
                  <button
                    mat-button
                    color="primary"
                    (click)="tablesShowD[i] = !tablesShowD[i]"
                  >
                    <mat-icon>{{
                      tablesShowD[i]
                        ? "keyboard_arrow_up"
                        : "keyboard_arrow_down"
                    }}</mat-icon>
                  </button>
                </td>
                <td *ngIf="p.dispositivos.length === 0">
                  <button
                    mat-button
                    color="primary"
                    (click)="reporTableFunDisp(i)"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </td>

                <td *ngIf="p.tipoDatos.length > 0">
                  <button
                    mat-button
                    color="primary"
                    (click)="tablesShowT[i] = !tablesShowT[i]"
                  >
                    <mat-icon>{{
                      tablesShowT[i]
                        ? "keyboard_arrow_up"
                        : "keyboard_arrow_down"
                    }}</mat-icon>
                  </button>
                </td>
                <td *ngIf="p.tipoDatos.length === 0">
                  <button
                    mat-button
                    color="primary"
                    (click)="reporTableFunDato(i)"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="tablesShowT[i] && p.tipoDatos.length > 0">
                <td colspan="12 ">
                  <!--<br>Datos:<br>-->
                  <table BORDER="1 ">
                    <tr *ngFor="let d of p.tipoDatos; let ii = index">
                      <td>
                        <button
                          mat-button
                          color="primary"
                          (click)="tablesEditTFun(i, ii)"
                        >
                          <mat-icon>create</mat-icon>
                        </button>
                      </td>
                      <td>
                        <button
                          mat-button
                          color="primary"
                          (click)="borrarTablesTipoDato(i, ii)"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                      <td>{{ d.uuid }}</td>
                      <td>
                        <input
                          *ngIf="tablesEditT[i].dato[ii]"
                          type="text"
                          [(ngModel)]="d.codigo"
                        />
                        <span *ngIf="!tablesEditT[i].dato[ii]">{{
                          d.codigo
                        }}</span>
                      </td>
                      <td>
                        <table>
                          <tr>
                            <td>Dato (uuid):</td>
                            <td>{{ d.tipoDatos.uuid }}</td>
                          </tr>
                          <tr>
                            <td>Dato (nombre):</td>
                            <td>{{ d.tipoDatos.nombre }}</td>
                          </tr>
                          <tr>
                            <td>Dato (unidad):</td>
                            <td>{{ d.tipoDatos.unidad }}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <button
                    mat-button
                    color="primary"
                    (click)="reporTableFunDato(i)"
                  >
                    <mat-icon>list_alt</mat-icon><mat-icon>add</mat-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="tablesShowD[i] && p.dispositivos.length > 0">
                <td colspan="12 ">
                  <!--<br>Datos:<br>-->
                  <table BORDER="1 ">
                    <tr *ngFor="let d of p.dispositivos; let ii = index">
                      <td>
                        <button
                          mat-button
                          color="primary"
                          (click)="tablesEditDFun(i, ii)"
                        >
                          <mat-icon>create</mat-icon>
                        </button>
                      </td>
                      <td>
                        <button
                          mat-button
                          color="primary"
                          (click)="borrarTablesDispositivos(i, ii)"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                      <td>{{ d.uuid }}</td>
                      <td>
                        <input
                          *ngIf="tablesEditD[i].dato[ii]"
                          type="text"
                          [(ngModel)]="d.codigo"
                        />
                        <span *ngIf="!tablesEditD[i].dato[ii]">{{
                          d.codigo
                        }}</span>
                      </td>
                      <td>
                        <table>
                          <tr>
                            <td>Disp.(uuid):</td>
                            <td>{{ d.dispositivo.uuid }}</td>
                          </tr>
                          <tr>
                            <td>Disp.(nombre):</td>
                            <td>{{ d.dispositivo.nombre }}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <button
                    mat-button
                    color="primary"
                    (click)="reporTableFunDisp(i)"
                  >
                    <mat-icon>device_hub</mat-icon><mat-icon>add</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <button mat-button color="primary" (click)="reportTableFun()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </mat-tab>
      </mat-tab-group>
      <!--<a class="mat-raised-button " style="background-color: blue; color: white; " routerLink="/informes "> VOLVER </a>-->
    </div>
  </div>
</div>
<div class="espera">
  <ng-template #cargando>
    <mat-spinner class="espera"></mat-spinner>
    <span>Cargando ..</span>
  </ng-template>
</div>
